import styled, {css} from 'styled-components'
import {Popover} from '@ariakit/react'

export const StyledPopover = styled(Popover)(
    ({theme: {palette, shadows, zIndex}}) => css`
        background-color: ${palette.neutral[50]};
        border-radius: 8px;
        box-shadow: ${shadows.lg};
        border: 1px solid ${palette.neutral[200]};
        z-index: ${zIndex.modal};
    `
)

export const StyledPopoverContent = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        display: flex;
        flex-direction: column;
        gap: ${spacing}px;
        align-items: flex-start;
    `
)

export const StyledField = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        width: 100%;
        grid-template-columns: 80px minmax(180px, max-content) max-content max-content auto;
        gap: ${spacing * 1.5}px;
        align-items: center;
        padding: ${spacing * 1.5}px;
    `
)

export const StyledWhere = styled.span(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
    `
)

export const StyledSelectedOperator = styled.div(
    ({theme: {typography, palette, spacing}}) => css`
        ${typography.textSm};
        width: 100%;
        background-color: ${palette.neutral[100]};
        color: ${palette.neutral[950]};
        border-radius: 6px;
        padding: ${spacing}px ${spacing * 2}px;
    `
)

export const StyledFooter = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 2.5}px ${spacing * 2}px;
        display: flex;
        justify-content: space-between;
        gap: ${spacing * 2}px;
    `
)
